import request from '@/utils/request';

export interface WorkTicketFieldValue {
  field_type: number;
  field_name: string;
  field_value: string | number | null;
  sequence_no: number;
}

export interface WorkTicketSkuItem {
  id?: string;
  relation_id?: string;
  ref_task_id?: string;
  zone_id?: string;
  location_id?: string;
  station_id?: string;
  sku_id?: string;
  sku_name?: string;
  sku_image?: string;
  sku_images?: string[] | string;
  expected_qty?: string | number;
}

export interface WorkTicketDetail extends WorkTicketSkuItem {
  ticket_id?: string;
  ticket_status?: number;
  action_status?: number;
  process_type?: number | string;
  stage_type?: number | string;
  ticket_type_name?: string;
  creator?: string;
  assignee?: string;
  ctime?: number;
  duration_time?: number;
  remark?: string;
  field_values?: WorkTicketFieldValue[];
  sku_list?: WorkTicketSkuItem[];
}

export interface WorkTicketActionItem extends WorkTicketSkuItem {
  action_status?: number;
  assignee?: string;
  remark?: string;
}

export interface SearchTicketListRequest {
  ticket_id?: string;
  creator?: string;
  assignee?: string;
  ctime_from?: number;
  ctime_to?: number;
  zone_id?: string;
  pathway_id?: string;
  ref_task_id?: string;
  ever_appealed?: number;
  is_replica?: number;
  pageno?: number;
  count?: number;
  ticket_type?: number;
  ticket_status?: number;
  ticket_status_list?: string;
  location_id?: string;
  process?: number | string;
  stage?: number | string;
  ticket_type_name?: string;
  ticket_type_id?: string;
  station_id?: string;
  pending_my_actions_only?: number;
}

export const searchTicketList = async (params: SearchTicketListRequest) => {
  const res = await request.get(
    /* PermissionKey: PC.WorkTicketManagement.WorkTicketManagement */
    '/api/v2/apps/process/inventory/ticket/search_ticket_list',
    {
      params: {
        ...params,
      },
    }
  );
  return res;
};

export const searchTicketDetail = async (params: { ticket_id: string }) => {
  const res = await request.get(
    /* PermissionKey: PC.WorkTicketManagement.WorkTicketManagement.view */
    '/api/v2/apps/process/inventory/ticket/search_ticket_detail',
    {
      params: {
        ...params,
      },
    }
  );
  return res;
};

export interface SearchTicketActionListRequest {
  ticket_id: string;
}

export interface SearchTicketActionListResponse {
  action_list?: WorkTicketActionItem[];
}

export const searchTicketActionList = async (
  params: SearchTicketActionListRequest
) => {
  const res = await request.get(
    /* PermissionKey: PC.WorkTicketManagement.WorkTicketManagement.view */
    '/api/v2/apps/process/inventory/ticket/search_ticket_action_list',
    {
      params: {
        ...params,
      },
    }
  );
  return res;
};

export const searchTicketOperationLog = async (params: {
  ticket_id: string;
}) => {
  const res = await request.get(
    /* PermissionKey: PC.WorkTicketManagement.WorkTicketManagement.view */
    '/api/v2/apps/process/inventory/ticket/search_ticket_operation_log',
    {
      params: {
        ...params,
      },
    }
  );
  return res;
};

export interface InterfaceDoTicketAction {
  id: number;
  action_code: number;
  action_source?: number;
}

export const doTicketAction = async (params: InterfaceDoTicketAction) => {
  const res = await request.post(
    /* PermissionKey: PC.WorkTicketManagement.WorkTicketManagement.Handle */
    '/api/v2/apps/process/inventory/ticket/do_ticket_action',
    {
      ...params,
    }
  );
  return res;
};
